import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean";
import { _TaxScheme } from "../../../../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG } from "../../../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { BasicTable, MASK_NUMBER } from "../../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../../theme/Component/Modal";
import { SelectTaxSchemeContext } from "../../../../../../../admin/ConfImpuestos/TaxSchemeCode/SelectTaxSchemeContext";
import { TaxSchemeTypeEditor } from "../../../../../../../admin/ConfImpuestos/TaxScheme/TaxSchemeType.editor";

interface Props {
    onChange: any;
    label?: string;
    idTaxSchemContext?: number;
}

interface FormProps {
    IDschemeContext: number;
    TaxType: number;
}

export const RemoteTaxScheme = ({ onChange, label, idTaxSchemContext }: Props) => {

    const { instance, lista, bean, setBean, setLista } = useDataBean(_TaxScheme);
    const [renderValue, setRenderValue] = useState<string>("");
    const [form, setForm] = useState<FormProps>({
        IDschemeContext: idTaxSchemContext ? idTaxSchemContext : null,
        TaxType: null
    })

    const modal = useModal("Seleccione un Tipo de Impuestos", MODAL_LG);

    useEffect(() => {
        if (form.IDschemeContext && form.TaxType >= 0) {
            getLista();
        }
    }, [form])

    const getLista = () => {
        instance.getTaxSchemeCatalog(form.IDschemeContext, form.TaxType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const head = [
        { title: 'ID', property: 'IDTaxScheme', visible: true, mask: MASK_NUMBER },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo de Impuesto', property: 'TaxSchemeTypeName', visible: true },
        { title: 'Cuenta Contable Retención/Descuento', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Contable Vr Agregado', property: 'AccountantIDAddedValueName', visible: true },
        { title: 'Cuenta Contable Consumo', property: 'AccountantIDOwnConsumptionName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Aplicar a Códigos de Actividad Unicamente', property: 'ApplyCodeFilter', visible: true },
    ]

    const selectItem = () => {

        if (bean.IDTaxScheme) {
            setRenderValue(`${bean.Code} - ${bean.Name}`)
            modal.close();
            onChange?.(bean)
        } else {
            toast.error("Tipo de Impuesto no valido")
        }
    }

    return (
        <>
            <label>{label ? label : 'Tipo de Impuesto'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    {!idTaxSchemContext &&
                        <div className="col-6">
                            <SelectTaxSchemeContext label="Esquemas de Recaudo de Impuestos" idSelector={form.IDschemeContext} onChange={(e) => { setForm({ ...form, IDschemeContext: e }) }} />
                        </div>
                    }
                    <div className="col-6">
                        <TaxSchemeTypeEditor idSelector={form.TaxType} onChange={(e) => { setForm({ ...form, TaxType: e }) }} />
                    </div>
                    <div className="col-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}